import { render } from "./DeepPerformanceThreadPerformance.vue?vue&type=template&id=4dcc909c&scoped=true&ts=true"
import script from "./DeepPerformanceThreadPerformance.vue?vue&type=script&lang=ts"
export * from "./DeepPerformanceThreadPerformance.vue?vue&type=script&lang=ts"

import "./DeepPerformanceThreadPerformance.vue?vue&type=style&index=0&id=4dcc909c&scoped=true&lang=css"
import "./DeepPerformanceThreadPerformance.vue?vue&type=style&index=1&id=4dcc909c&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dcc909c"]])

export default __exports__